import {
  EditDeleteButton,
  EditDeleteContainer,
} from "./EditDeleteComponent.style";

const EditDeleteComponent = (props: any) => {
  const { options, assignment } = props;

  return (
    <EditDeleteContainer>
      {options.map((option: any) => (
        <EditDeleteButton
          style={{ ...option.style }}
          key={option.name}
          onClick={() => {
            if (option.name === "Delete") {
              if (assignment !== null) {
                option.select(assignment.assignmentId);
                return;
              } else {
                option.select();
              }
            } else {
              option.select(assignment, option.current);
            }
          }}
          disabled={option.disabled}
        >
          {option.name}
        </EditDeleteButton>
      ))}
    </EditDeleteContainer>
  );
};

export default EditDeleteComponent;
